import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../../../services/config";
import { useAlert } from "react-alert";
import { Field, useFormik, Form, Formik } from "formik";
import * as Yup from "yup";
import { Alert } from "react-bootstrap";
import { Input } from "../../../../../_metronic/_partials/controls";
import DefineLoan from "../DefineLoan/DefineLoan";

const DefineSallary = ({ staffDetails, show, reload, campusID }) => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");

  const [loading, setloading] = useState(false);
  const [AllPayScales, setAllPayScales] = useState([]);
  const [showerr, setshowerr] = useState(false);
  const [showerror, setshowerror] = useState("Please Fill all Fields");
  const [alreadygeneratedsalary, setalreadygeneratedsalary] = useState({});
  const [myValues, setMyValue] = useState({});
  const [overAllTotal, setOverAllTotal] = useState(0);
  const [loanModal, setloanModal] = useState(false);

  useEffect(() => {
    getSalaryDetail();
    getAllPayScales();
  }, []);

  const getSalaryDetail = () => {
    fetch(`${baseUrl}/emp-salary-detail/${staffDetails.id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setalreadygeneratedsalary(data.payload);
          }
        } else {
          alert.error("No Records Found");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllPayScales = () => {
    fetch(`${baseUrl}/payscales`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setAllPayScales(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateHandler = (values) => {
    setloading(true);
    const data = {
      pay_scale_id: parseInt(values.pay_scale_id),
      dpt_allowance:
        values.dpt_allowance == "" ? 0 : parseInt(values.dpt_allowance),
      hostel: values.hostel == "" ? 0 : parseInt(values.hostel),
      college: values.college == "" ? 0 : parseInt(values.college),
      additional_allowance:
        values.additional_allowance == ""
          ? 0
          : parseInt(values.additional_allowance),
      increment: values.increment == "" ? 0 : parseInt(values.increment),
      second_shift:
        values.second_shift == "" ? 0 : parseInt(values.second_shift),
      adp_allowance:
        values.adp_allowance == "" ? 0 : parseInt(values.adp_allowance),
      navttc_allowance:
        values.navttc_allowance == "" ? 0 : parseInt(values.navttc_allowance),
      intermediate_allowance:
        values.intermediate_allowance == ""
          ? 0
          : parseInt(values.intermediate_allowance),
      bs_allowance:
        values.bs_allowance == "" ? 0 : parseInt(values.bs_allowance),
      extra_period:
        values.extra_period == "" ? 0 : parseInt(values.extra_period),
      invigilator_duty_allowance:
        values.invigilator_duty_allowance == ""
          ? 0
          : parseInt(values.invigilator_duty_allowance),
      convance: values.convance == "" ? 0 : parseInt(values.convance),
      eobi: values.eobi == "" ? 0 : parseInt(values.eobi),
      income_tax: values.income_tax == "" ? 0 : parseInt(values.income_tax),
      insurance: values.insurance == "" ? 0 : parseInt(values.insurance),
      van_charge: values.van_charge == "" ? 0 : parseInt(values.van_charge),
      other: values.other == "" ? 0 : parseInt(values.other),
      collected_gp_fund:
        values.collected_amount == "" ? 0 : parseInt(values.collected_amount),
      auto_clear_deduction: values.auto_clear_deduction,
    };
    fetch(`${baseUrl}/define-salary/${staffDetails.id}?_method=PUT`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          setloading(false);
          show(false);
          reload(campusID);
          if (data.metadata) {
            if (data.metadata.success) {
              alert.success("Salary has been defined");
              setloading(false);
              show(false);
            } else {
              show(false);
              setloading(false);
              const msgArray = Object.values(data.metadata.message);
              msgArray.map((err) => alert.error(err[0]));
            }
          } else {
            show(false);
            setloading(false);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        alert.error(err);
        show(false);
      });
  };
  const gettingNetPay = () => {
    const basic =
      Number(staffDetails?.pay_scale?.basic) +
      Number(alreadygeneratedsalary?.salaryAlowance?.all_allowance_total);
    const ducduction =
      Number(alreadygeneratedsalary?.salaryDeduction?.all_deduction_total) +
      Number(staffDetails?.pay_scale?.gp_fund) +
      Number(staffDetails?.pay_scale?.welfare_fund);
    return " " + basic - ducduction;
  };

  const calcularteClick = () => {
    const basic =
      Number(myValues.basic) +
      Number(myValues.dpt_allowance) +
      Number(myValues.hostel) +
      Number(myValues.college) +
      Number(myValues.additional_allowance) +
      Number(myValues.second_shift) +
      Number(myValues.increment) +
      Number(myValues.intermediate_allowance) +
      Number(myValues.adp_allowance) +
      Number(myValues.navttc_allowance) +
      Number(myValues.bs_allowance) +
      Number(myValues.extra_period) +
      Number(myValues.invigilator_duty_allowance);
    const ducduction =
      Number(myValues.eobi) +
      Number(myValues.income_tax) +
      Number(myValues.van_charge) +
      Number(myValues.insurance) +
      Number(myValues.other) +
      Number(staffDetails?.pay_scale?.gp_fund) +
      Number(staffDetails?.pay_scale?.welfare_fund);
    setOverAllTotal(basic - ducduction);
  };

  //start here

  const AppointStaffSchema = Yup.object().shape({
    pay_scale_id: Yup.string().required("Pay Scale is required "),

    dpt_allowance: Yup.string()
      .notRequired("DPT  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    hostel: Yup.string()
      .notRequired("Hostel Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    college: Yup.string()
      .notRequired("College is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    additional_allowance: Yup.string()
      .notRequired("Additional Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    increment: Yup.string()
      .notRequired("Increment  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    second_shift: Yup.string()
      .notRequired("Second Shift Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    adp_allowance: Yup.string()
      .notRequired("ADP Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),

    navttc_allowance: Yup.string()
      .notRequired("Navttc Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),

    intermediate_allowance: Yup.string()
      .notRequired("Intermediate Allowance Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    bs_allowance: Yup.string()
      .notRequired("BS Allowance Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    extra_period: Yup.string()
      .notRequired("Extra Period is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    invigilator_duty_allowance: Yup.string()
      .notRequired("Invigilator Duty Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    convance: Yup.string()
      .notRequired("Convance  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    eobi: Yup.string()
      .notRequired("EOBI Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    income_tax: Yup.string()
      .notRequired("Income Tax is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    insurance: Yup.string()
      .notRequired("Insurance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    van_charge: Yup.string()
      .notRequired("Van Charge  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    other: Yup.string()
      .notRequired("other  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    collected_amount: Yup.string()
      .notRequired("Collected GP Fund  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
  });

  const createEroors = (errors, touched, isSubmitting, values) => {
    if (errors.pay_scale_id && touched.pay_scale_id) {
      setshowerror("Pay scale id is required");
      setshowerr(true);
      return;
    }

    setshowerr(false);

    if (Object.keys(errors).length === 0) {
      if (values.pay_scale_id != "") {
        if (isSubmitting) {
          if (!values.issubmitted) {
            values.issubmitted = true;

            updateHandler(values);
          }
        }
      }
    }
  };

  const defineLoan = () => {
    setloanModal(true);
  };

  const checkTheValue = (values, handleChange) => {
    setMyValue(values);
  };

  return (
    <div>
      {loading ? (
        <b style={{ color: "green" }}>
          Salary
          {Object.values(alreadygeneratedsalary).length == 0
            ? "Defining"
            : "Updating"}
          Please Wait <span className="spinner-borderd"></span>
        </b>
      ) : (
        <div>
          <div className="container-fluid">
            <div className="row d-flex justify-content-center ">
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <div>
                  <Formik
                    enableReinitialize={true}
                    initialValues={
                      Object.values(alreadygeneratedsalary).length == 0
                        ? {
                            issubmitted: false,
                            pay_scale_id:
                              staffDetails.pay_scale_id == null
                                ? ""
                                : staffDetails.pay_scale_id,
                            dpt_allowance: "",

                            hostel: "",
                            college: "",
                            additional_allowance: "",
                            increment: "",

                            second_shift: "",
                            adp_allowance: "",
                            intermediate_allowance: "",
                            navttc_allowance: "",

                            bs_allowance: "",
                            extra_period: "",
                            invigilator_duty_allowance: "",
                            convance: "",

                            eobi: "",
                            income_tax: "",
                            insurance: "",
                            van_charge: "",
                            other: "",
                            auto_clear_deduction: false,
                          }
                        : {
                            issubmitted: false,

                            pay_scale_id:
                              staffDetails.pay_scale_id == null
                                ? ""
                                : staffDetails.pay_scale_id,

                            dpt_allowance:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.dpt_allowance,
                            basic: staffDetails?.pay_scale?.basic,
                            hostel:
                              alreadygeneratedsalary?.salaryAlowance?.hostel,
                            college:
                              alreadygeneratedsalary?.salaryAlowance?.college,
                            additional_allowance:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.additional_allowance,
                            increment:
                              alreadygeneratedsalary?.salaryAlowance?.increment,

                            second_shift:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.second_shift,
                            adp_allowance:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.adp_allowance,
                            intermediate_allowance:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.intermediate_allowance,
                            navttc_allowance:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.navttc_allowance,

                            bs_allowance:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.bs_allowance,
                            extra_period:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.extra_period,
                            invigilator_duty_allowance:
                              alreadygeneratedsalary?.salaryAlowance
                                ?.invigilator_duty_allowance,
                            convance:
                              alreadygeneratedsalary?.salaryAlowance?.convance,

                            eobi: alreadygeneratedsalary?.salaryDeduction?.eobi,
                            income_tax:
                              alreadygeneratedsalary?.salaryDeduction
                                ?.income_tax,
                            insurance:
                              alreadygeneratedsalary?.salaryDeduction
                                ?.insurance,
                            van_charge:
                              alreadygeneratedsalary?.salaryDeduction
                                ?.van_charge,
                            other:
                              alreadygeneratedsalary?.salaryDeduction?.other,
                            collected_amount:
                              alreadygeneratedsalary?.gp_collected_fund
                                ?.collected_amount,
                            auto_clear_deduction:
                              staffDetails?.auto_clear_deduction === 1,
                          }
                    }
                    validationSchema={AppointStaffSchema}
                    onSubmit={(values) => {}}
                  >
                    {(props) => {
                      const {
                        handleSubmit,
                        errors,
                        touched,
                        setFieldValue,
                        values,
                        isSubmitting,
                        isValid,
                        handleChange,
                        handleBlur,
                      } = props;

                      // setErrorsLis(errors)
                      createEroors(errors, touched, isSubmitting, values);
                      checkTheValue(values, handleChange);

                      return (
                        <>
                          <Form
                            onSubmit={handleSubmit}
                            className="form form-label-right"
                          >
                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-6 flex-column d-flex ">
                                <label className="form-control-label">
                                  <b>
                                    Pay Scale{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <select
                                  className="form-select form-control"
                                  name="pay_scale_id"
                                  value={values.pay_scale_id || ""}
                                  onChange={(e) => {
                                    const data = AllPayScales.find(
                                      (item) => item.id == e.target.value,
                                    );

                                    setFieldValue(
                                      "pay_scale_id",
                                      e.target.value,
                                    );
                                    setFieldValue("basic", data.basic);
                                  }}
                                  onBlur={handleBlur}
                                  aria-label="Default select example"
                                >
                                  <option value="">Select Payscale</option>

                                  {AllPayScales?.map((payscle) => (
                                    <option key={payscle.id} value={payscle.id}>
                                      {payscle.payscale}
                                    </option>
                                  ))}
                                </select>
                                {errors.pay_scale_id && touched.pay_scale_id && (
                                  <div
                                    style={{ color: "#f87d8a" }}
                                    className="input-feedback"
                                  >
                                    Pay scale id is required
                                  </div>
                                )}
                              </div>
                            </div>

                            <h3 className="m-3"> Salary Allowance</h3>
                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Basic Salary</b>
                                </label>
                                <Field
                                  disabled
                                  name="basic"
                                  component={Input}
                                  placeholder="Basic"
                                />
                              </div>
                            </div>
                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>DPT Allowance</b>
                                </label>
                                <Field
                                  name="dpt_allowance"
                                  component={Input}
                                  placeholder="DPT Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Hostel </b>
                                </label>
                                <Field
                                  name="hostel"
                                  component={Input}
                                  placeholder="Hostel"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>College </b>
                                </label>
                                <Field
                                  name="college"
                                  component={Input}
                                  placeholder="College"
                                />
                              </div>
                            </div>
                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Additional </b>
                                </label>
                                <Field
                                  name="additional_allowance"
                                  component={Input}
                                  placeholder="Additional Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Increment </b>
                                </label>
                                <Field
                                  name="increment"
                                  component={Input}
                                  placeholder="increment"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Second Shift </b>
                                </label>
                                <Field
                                  name="second_shift"
                                  component={Input}
                                  placeholder="Second Shift"
                                />
                              </div>
                            </div>
                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>ADP Allowance</b>
                                </label>
                                <Field
                                  name="adp_allowance"
                                  component={Input}
                                  placeholder="ADP Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Intermediate Allowance</b>
                                </label>
                                <Field
                                  name="intermediate_allowance"
                                  component={Input}
                                  placeholder="Intermediate Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Navttc allowance </b>
                                </label>
                                <Field
                                  name="navttc_allowance"
                                  component={Input}
                                  placeholder="Navttc Allowance"
                                />
                              </div>
                            </div>

                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>BS Allowance</b>
                                </label>
                                <Field
                                  name="bs_allowance"
                                  component={Input}
                                  placeholder="BS Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Extra Period </b>
                                </label>
                                <Field
                                  name="extra_period"
                                  component={Input}
                                  placeholder="Extra Period"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Invigilator Duty</b>
                                </label>
                                <Field
                                  name="invigilator_duty_allowance"
                                  component={Input}
                                  placeholder="Invigilator Duty"
                                />
                              </div>
                            </div>

                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Convance </b>
                                </label>
                                <Field
                                  name="convance"
                                  component={Input}
                                  placeholder="Convance"
                                />
                              </div>
                            </div>

                            <h3 className="m-3">Salary Deduction Details</h3>

                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>E O B I </b>
                                </label>
                                <Field
                                  name="eobi"
                                  component={Input}
                                  placeholder="EOBI"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Income Tax </b>
                                </label>
                                <Field
                                  name="income_tax"
                                  component={Input}
                                  placeholder="Income Tax"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Van Charge </b>
                                </label>
                                <Field
                                  name="van_charge"
                                  component={Input}
                                  placeholder="Van Charge"
                                />
                              </div>
                            </div>
                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Insurance </b>
                                </label>
                                <Field
                                  name="insurance"
                                  component={Input}
                                  placeholder="Insurance"
                                />
                              </div>

                              <div className="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Other </b>
                                </label>
                                <Field
                                  name="other"
                                  component={Input}
                                  placeholder="Other"
                                />
                              </div>
                              <div className="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>Total GP Fund Collected </b>
                                </label>
                                <Field
                                  name="collected_amount"
                                  component={Input}
                                  placeholder="GP Fund Collected"
                                />
                              </div>

                              <div className="form-group col-sm-6 flex-column">
                                <Field
                                  type="checkbox"
                                  name="auto_clear_deduction"
                                  id="auto_clear_deduction"
                                />
                                <label
                                  htmlFor="auto_clear_deduction"
                                  className="form-control-label"
                                >
                                  <b>Auto Clear Deduction</b>
                                </label>
                              </div>
                            </div>
                          </Form>
                          {showerr ? (
                            <div id="err">
                              <Alert
                                variant="danger"
                                onClose={() => setshowerr(false)}
                                dismissible
                              >
                                <Alert.Heading>
                                  Oops You Got an Error!
                                </Alert.Heading>
                                <p>{showerror}</p>
                              </Alert>
                            </div>
                          ) : null}
                          <div className="d-flex mb-5">
                            <h4>Net Pay : </h4>
                            <h4>
                              {isNaN(overAllTotal) || overAllTotal == 0
                                ? isNaN(gettingNetPay())
                                  ? " 0"
                                  : " " + gettingNetPay() // Check if gettingNetPay() is NaN
                                : " " + overAllTotal}
                            </h4>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <button
                                style={{ alignSelf: "flex-start" }}
                                className="btn btn-success"
                                onClick={defineLoan}
                              >
                                Salary Loan
                              </button>
                              <button
                                style={{ alignSelf: "flex-start" }}
                                className="btn btn-primary mx-2"
                                onClick={calcularteClick}
                              >
                                Calculate
                              </button>
                            </div>

                            <div className="btns flex_last">
                              <button
                                type="submit"
                                value="Submit"
                                onClick={() => handleSubmit()}
                                // onClick={updateHandler}
                                className="btn btn-success button_blue pl-4 pr-4"
                              >
                                {Object.values(alreadygeneratedsalary).length ==
                                0
                                  ? "Define"
                                  : "Update"}
                              </button>
                              <button
                                onClick={() => show(false)}
                                className="btn_padding_left btn btn-danger btn_width  pl-4 pr-4 ml-3"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <DefineLoan
        visible={loanModal}
        employeDetails={staffDetails}
        closeModal={() => setloanModal(false)}
        reload={reload}
      />
    </div>
  );
};

export default DefineSallary;
